/**
 * Parser en JSON-array-streng (f.eks. `'["rød","blå"]'` levert av et string_agg-aggregat,
 * WI 2224) til en `string[]`. Returnerer `[]` for tom/ugyldig input — kaster aldri, slik at
 * Vue-komponenter slipper try/catch (store/helper eier feilhåndtering). Kun JSON-arrayer
 * aksepteres; andre JSON-verdier gir `[]`.
 */
export function parseJsonStringArray (value: string): string[] {
  const trimmed = value.trim();
  if (trimmed === '') return [];
  try {
    const parsed: unknown = JSON.parse(trimmed);
    return Array.isArray(parsed) ? parsed.map(String) : [];
  } catch {
    return [];
  }
}
